var EHDI = EHDI || Object.create(null);
var WAG = WAG || Object.create(null);


EHDI.scene.GameScene = function() {
    EHDI.aka.Container.call(this);

    // EHDI.scene.GameScene.game = new WAG.GameEngine();
    // EHDI.scene.GameScene.timer = new EHDI.components.Timer();
    //     EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.gametimelimit / 1000;
    //     EHDI.scene.GameScene.timer.x =  280;
    //     EHDI.scene.GameScene.timer.y =  5;
    // EHDI.GAME.pauseButton = new EHDI.components.pauseButton();

}

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.GameScene.prototype.init = function(){
    EHDI.scene.GameScene.game = new WAG.GameEngine();
    EHDI.scene.GameScene.timer = new EHDI.components.Timer();
        EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.gametimelimit / 1000;
        EHDI.scene.GameScene.timer.x =  280;
        EHDI.scene.GameScene.timer.y =  5;
    EHDI.GAME.pauseButton = new EHDI.components.pauseButton();
    
    EHDI.scene.GameScene.game.init();
    this.addChild(EHDI.scene.GameScene.game);
    EHDI.scene.GameScene.scoreHolder = EHDI.components.ScoreManager(this);
        EHDI.scene.GameScene.scoreHolder.setXY(10,5);
    this.addChild( EHDI.scene.GameScene.timer);
    this.addChild(EHDI.GAME.pauseButton);
}

EHDI.scene.GameScene.prototype.dispose = function() {
    
    
    if(EHDI.scene.GameScene.game)
    {
        this.removeChild(EHDI.scene.GameScene.game);
        EHDI.scene.GameScene.game.killListeners();
        EHDI.scene.GameScene.game.killGraphics();
        EHDI.scene.GameScene.game.killProps();
        EHDI.scene.GameScene.game.destroy();
    }
    delete EHDI.scene.GameScene.game
    
    if(EHDI.scene.GameScene.timer)
    {
        this.removeChild(EHDI.scene.GameScene.timer);
        EHDI.scene.GameScene.timer.dispose();
    }
    delete EHDI.scene.GameScene.timer;

    if(EHDI.GAME.pauseButton)
    {
        this.removeChild(EHDI.GAME.pauseButton);
        EHDI.GAME.pauseButton.destroy();
    }
    delete EHDI.GAME.pauseButton;

    
    
}

EHDI.scene.GameScene.prototype.screenWillAppear = function() {
    this.init();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function() {

    EHDI.scene.GameScene.game.gameStart();    
    if ( EHDI.GAME.saveData.isFirstTimePlay )
    {    
        EHDI.GAME.saveData.isFirstTimePlay = false;    
        EHDI.GAME.storageManager.setLocalInfo( EHDI.GAME.id, EHDI.GAME.saveData );
        /* EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
            console.log("data saved.");
        }); */
        EHDI.GAME.pauseButton.isPaused = true;
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }

};

EHDI.scene.GameScene.prototype.screenDidDisappear = function() {
    //this.destroy({children: true});
    
    this.dispose();
    this.destroy({children: true});
    delete this;
    
}



EHDI.scene.GameScene.prototype.replay = function() {
    this.dispose();
    this.init();
    
    EHDI.scene.GameScene.game.gameStart();
}

